import * as React from "react";
import Category from "@templates/category";
import Grid from "@components/Grid/Grid";
import {inject} from "mobx-react";

@inject("store")
export default class Filter extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        const model = this.props.navigation.pageContent;//model;
        const topGrid = <Grid
            {...this.props}
            model={model.Properties.heroGrid}
            resetProductIterator={this.resetProductIterator}
            pickProduct={this.pickProduct}
            productsCount={this.productsCount}
        />;


        return (
            <Category {...this.props}>
                <div className={"wrapper"}>
                    {topGrid}
                </div>
            </Category>
        );
    }
}

